import RegisterStaffLogModal from './RegisterStaffLogModal'

RegisterStaffLogModal.NAME = 'REGISTER_STAFF_LOG'

export default RegisterStaffLogModal
